import styled from 'styled-components';
import MaskedInput from 'react-text-mask';

import CustomIcon from '@components/utils/CustomIcon';

export const InputWrapper = styled.div`
  position: relative;

  width: auto;
  height: auto;
  display: flex;
`;

export const Label = styled.label`
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 36px;

  font-size: 12px;
  font-weight: bold;

  color: ${({ theme }) => theme.palette.darkGrey};

  user-select: none;
  pointer-events: none;
`;

export const Mask = styled(MaskedInput)<{ error?: boolean }>`
  border-width: 0 0 1px 0;
  border-color: ${({ error }) =>
    error ? 'rgba(226,35,27, 0.2)' : 'rgba(0, 0, 0, 0.2)'};

  box-sizing: border-box;
  width: 100%;
  height: 60px;
  padding: 33px 18px 15px 36px;

  color: ${({ error }) =>
    error ? 'rgba(226,35,27, 0.5)' : 'rgba(0, 0, 0, 0.5)'};

  font-size: 14px;

  outline: none;

  &:disabled {
    cursor: inherit;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    opacity: 0.5;
    font-size: 16px;
    color: ${({ theme, error }) =>
      error ? theme.palette.tomato : theme.palette.matterHorn};
  }
  :-ms-input-placeholder {
    opacity: 0.5;
    font-size: 16px;
    color: ${({ theme, error }) =>
      error ? theme.palette.tomato : theme.palette.matterHorn};
  }
`;

export const StyledCustomIcon = styled(CustomIcon)`
  top: 15px;
  position: absolute;
  margin-right: 15px;
  opacity: 1 !important;
`;

export const Error = styled.span`
  height: 19px;

  margin-top: 8px;

  color: ${({ theme }) => theme.palette.tomato};

  font-size: 14px;
`;
